import React from 'react';
import {
    Button,
    CircularProgress,
    MenuItem,
    Radio,
    RadioGroup,
    TextField,
    Grid,
    Typography
} from "@mui/material";
import { Form, Formik } from "formik";
import { useContext, useEffect, useRef, useState } from "react";
import DocumentTable from "../../../components/OB/BelgeYukleme";
import BilgilendirmePopup from "../../../components/OB/popups/BilgilendirmePopUp";
import SessionStorageService from "../../../services/StorageService";
import { useNavigate } from "react-router";
import AciklamaAndUserControlPopup from "../../../components/OB/popups/aciklama-usercontrol-popup";
import { toast } from "react-toastify";
import { safelyParseNumber } from '../../../helpers/MoneyFormat';
import YanginSigortaVergisiBasvuruAPI from '../../../apis/OB/SaveApi/YanginSigortaVergisiBasvuruAPI';
import * as Yup from 'yup';
import { ConstantAPISContext } from "../../../context/ConstantAPISContext";
import { year } from "../../../helpers/TodayDate";
import SabitBilgiAPI from "../../../apis/OB/Get/SabitBilgiGetAPI";
import Recaptcha from "../../../components/Recaptcha";
import DysAPI from "../../../apis/DysAPI";

const validationSchema = Yup.object({
    beyanYili: Yup.number().required('Beyan yılı zorunludur.'),
    beyanAyi: Yup.number().required('Beyan ayı zorunludur.'),
});

const YanginSigortaVergisiBasvuru = (props: any) => {
    const [userControlPopup, setUserControlPopup] = useState(false);
    const user = SessionStorageService.getUserInfo()
    const [isLoad, setIsLoad] = useState(true);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupAciklama, setPopupAciklama] = useState("");
    const navigate = useNavigate();
    const [kayitBasarili, setKayitBasarili] = useState(false);
    const { mahalleListe, yilListe } = useContext(ConstantAPISContext);
    const [oranlar, setOranlar] = useState({ mnk: 0, gmnk: 0 });
    const recaptchaRef = useRef<any>(null);
    const [recaptchaPassed, setRecaptchaPassed] = useState(false);
    const [recaptchaError, setRecaptchaError] = useState(false);

    const [documents, setDocuments] = useState<any[]>([]);
    const [docsLoaded, setDocsLoaded] = useState<boolean>(false);
    const documentTableRef = useRef<HTMLDivElement | null>(null);

    const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);

    const handleUpdateDocuments = (updatedDocuments: any) => {
        setDocuments(updatedDocuments);
    };

    useEffect(() => {
        setDocsLoaded(false);

        DysAPI.obBasvuruTanimBelgeList({ rfObBasvuruTanim: 8 })
            .then((res: any) => {
                console.log("Belge listesi response:", res.data);

                const list = (res?.data ?? []).map((b: any, idx: number) => {
                    const zorunlu = (b.zorunluEh)
                        .toString();

                    return {
                        id: b.sqId,
                        documentName: b.belgeAdi,
                        isRequired: ["E"].includes(zorunlu),
                        fileName: "",
                        file: null,
                    };
                });


                setDocuments(list);
            })
            .catch((err: any) => {
                console.error("Belge listesi hatası:", err);
                setDocuments((prevDocs: any[]) =>
                    prevDocs.map((doc) => ({
                        ...doc,
                        file: null,
                        fileName: "",
                    }))
                );
            })
            .finally(() => {
                setDocsLoaded(true);
            });
    }, []);

    useEffect(() => {
        if (user == null) {
            setUserControlPopup(true);
        } else {
            setIsLoad(false);
        }

    }, []);

    useEffect(() => {
        SabitBilgiAPI.getSabitBilgi()
            .then((res) => {
                const data = res.data[0];
                setOranlar({
                    mnk: data?.yanginSigortaMnkOran ?? 0,
                    gmnk: data?.yanginSigortaGmnkOran ?? 0
                });
            })
            .catch((err) => {
                console.error("Oranlar alınamadı:", err);
            });
    }, []);


    const closePopupSonuc = () => {
        setIsPopupVisible(false);
        setPopupAciklama("");
    };

    const closeUserControlPopup = () => {
        setUserControlPopup(false);
        navigate(-1);
    }

    return (
        isLoad ? <>
            <div className="d-flex align-self-strech justify-content-center align-items-center"> <CircularProgress /></div>
            {userControlPopup ? (

                <AciklamaAndUserControlPopup
                    open={userControlPopup}
                    handleClose={closeUserControlPopup}
                    isUserControlPopUp={true}
                    description={"Bu sayfayı kullanmak için giriş yapmalısınız."}
                />

            ) : null}
        </> :
            <Formik
                validateOnMount={true}
                validationSchema={validationSchema}
                initialValues={{
                    basvuruTuruId: 8,
                    sicilKodu: user?.sicilKodu ?? 0,
                    beyanYili: year,
                    beyanAyi: null,
                    vergiyeTabiMenkulPrim: null,
                    vergiyeTabiGmenkulPrim: null,
                    yanginSigortaMnkOran: null,
                    yanginSigortaGmnkOran: null,
                    menkulOdenecekVergi: null,
                    gmenkulOdenecekVergi: null,
                    topVergiyeTabiPrim: null,
                    topOdeneckVergi: null,
                    aciklama: "",
                    ipAdresi: "",
                    kaydeden: user?.username ?? "ONLINEBELEDIYEM",
                }}
                onSubmit={async (values: any, { resetForm }) => {
                    const missingDocuments = documents
                        .filter(doc => doc.isRequired) // zorunlu belgeler
                        .filter(doc => !doc.fileName);     // henüz yüklenmemiş olanlar

                    if (missingDocuments.length > 0) {
                        const missingDocNames = missingDocuments.map(d => d.documentName).join(", ");
                        toast.error(`Lütfen şu zorunlu belgeleri yükleyin: ${missingDocNames}`);
                        documentTableRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
                        return; // başvuru burada durur
                    }

                    const { vergiyeTabiMenkulPrim, vergiyeTabiGmenkulPrim } = values;

                    if (
                        (vergiyeTabiMenkulPrim === null || vergiyeTabiMenkulPrim === 0 || vergiyeTabiMenkulPrim === '') &&
                        (vergiyeTabiGmenkulPrim === null || vergiyeTabiGmenkulPrim === 0 || vergiyeTabiGmenkulPrim === '')
                    ) {
                        setPopupAciklama(
                            'Başvuru yapabilmeniz için "Vergiye Tabi Olan Menkul Prim Tutarı” ve “Vergiye Tabi Olan Gayrimenkul Prim Tutarı” alanlarından en az birinin doldurulmuş olması gerekmektedir.'
                        );
                        setIsPopupVisible(true);
                        return;
                    }

                    // reCAPTCHA’yı tetikle
                    const token = await recaptchaRef.current?.handleSubmit();
                    if (!token) {
                        toast.error("reCAPTCHA doğrulanamadı, lütfen tekrar deneyiniz.");
                        return;
                    }

                    setLoadingSubmit(true);
                    const transformedValues = {
                        ...values,
                        basvuruTuruId: safelyParseNumber(values.basvuruTuruId),
                        sicilKodu: safelyParseNumber(values.sicilKodu),
                        beyanYili: safelyParseNumber(values.beyanYili),
                        beyanAyi: safelyParseNumber(values.beyanAyi),
                        vergiyeTabiMenkulPrim: safelyParseNumber(values.vergiyeTabiMenkulPrim),
                        vergiyeTabiGmenkulPrim: safelyParseNumber(values.vergiyeTabiGmenkulPrim),
                        yanginSigortaMnkOran: safelyParseNumber(oranlar.mnk),
                        yanginSigortaGmnkOrani: safelyParseNumber(oranlar.gmnk),
                        menkulOdenecekVergi: (safelyParseNumber(values.vergiyeTabiMenkulPrim) || 0) * (safelyParseNumber(oranlar.mnk) || 0),
                        gmenkulOdenecekVergi: (safelyParseNumber(values.vergiyeTabiGmenkulPrim) || 0) * (safelyParseNumber(oranlar.gmnk) || 0),
                        topVergiyeTabiPrim: (safelyParseNumber(values.vergiyeTabiMenkulPrim) || 0) + (safelyParseNumber(values.vergiyeTabiGmenkulPrim) || 0),
                        topOdeneckVergi: (safelyParseNumber(values.vergiyeTabiMenkulPrim) || 0) * (safelyParseNumber(oranlar.mnk) || 0) +
                            (safelyParseNumber(values.vergiyeTabiGmenkulPrim) || 0) * (safelyParseNumber(oranlar.gmnk) || 0),
                        aciklama: values.aciklama?.trim() ?? "",
                        ipAdresi: values.ipAdresi,
                        kaydeden: values.kaydeden ?? "ONLINEBELEDIYEM",
                        captchaToken: token
                    };
                    console.log("Transformed values:", transformedValues);
                    YanginSigortaVergisiBasvuruAPI.saveYsvBasvuru(transformedValues)
                        .then(async (res) => {
                            const data = res?.data;
                            if (data?.sonuc === 0) {
                                let basvuruNo = data.basvuruNo;

                                // DYS API'yi çağır 
                                try {
                                    // Sadece dosyası olanları al
                                    const filesToSend = documents.filter((doc: any) => !!doc.file);

                                    if (filesToSend.length > 0) {
                                        const formData = new FormData();

                                        filesToSend.forEach((doc: any) => {
                                            formData.append("files", doc.file, doc.file.name);
                                            formData.append("rfObBasvuruTanimBelge", String(doc.id));
                                        });

                                        formData.append("basvuruTuru", String(values.basvuruTuruId || 0));
                                        formData.append("basvuruId", String(basvuruNo));
                                        formData.append("folderName", "AKOS");
                                        formData.append("kurumId", "1");
                                        formData.append("versionable", "1");

                                        const response = await DysAPI.upload(formData);
                                        toast.warning(response.message);
                                    } else {
                                        // Burada return yok — sadece DYS çağrısını atlıyoruz.
                                        
                                    }
                                } catch (error: any) {
                                    toast.error("DYS upload hazırlama hatası:", error);
                                }

                                setPopupAciklama("İşleminiz başarıyla gerçekleştirildi. Başvuru Numaranız: " + basvuruNo);
                                resetForm();
                                setKayitBasarili(true);
                                setDocuments((prevDocs: any[]) =>
                                    prevDocs.map((doc) => ({
                                        ...doc,
                                        file: null,
                                        fileName: "",
                                    }))
                                );
                            } else {
                                setPopupAciklama(res?.sonucAciklama ?? "İşlem başarısız.");
                                setKayitBasarili(false);
                            }
                        })
                        .catch((err) => {
                            setPopupAciklama("İşleminizi gerçekleştirirken bir hata oluştu. Lütfen tekrar deneyiniz (API error).");
                            setKayitBasarili(false);
                        })
                        .finally(() => {
                            setIsPopupVisible(true);
                            recaptchaRef.current?.reset();
                            setLoadingSubmit(false);
                        });
                }}

            >
                {(formikProps) => {



                    const showToastIfErrorsExist = () => {
                        if (Object.keys(formikProps.errors).length > 0) {
                            focusFirstErrorField();
                            toast.error("Lütfen zorunlu alanları doldurun!");

                        }
                    };
                    const focusFirstErrorField = () => {
                        const errorKeys = Object.keys(formikProps.errors);
                        if (errorKeys.length > 0) {
                            const firstErrorKey = errorKeys[0];
                            console.log(errorKeys[0])
                            const element = document.querySelector(`[name="${firstErrorKey}"]`);
                            if (element) {
                                (element as HTMLElement).focus();
                            }
                        }
                    };

                    return (
                        <Form onSubmit={formikProps.handleSubmit}>
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <div className="d-flex justify-content-end align-self-stretch">
                                        <Button
                                            type="button"
                                            onClick={() => {
                                                formikProps.resetForm({ values: formikProps.initialValues });
                                                setDocuments((prevDocs: any[]) =>
                                                    prevDocs.map((doc) => ({
                                                        ...doc,
                                                        file: null,
                                                        fileName: "",
                                                    }))
                                                );
                                            }}
                                            color="secondary"
                                        >
                                            Temizle
                                        </Button>
                                    </div>
                                </div>
                                <div className="col-12 mb-3">
                                    <div className="card shadow-none border w-100">
                                        <div className="bg-white px-3 py-1 small fw-semibold">
                                            YANGIN SİGORTA VERGİSİ BEYAN BİLGİLERİ
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-lg-3">
                                                    <TextField
                                                        fullWidth
                                                        className="mb-3"
                                                        select
                                                        label="Beyan Yılı"
                                                        size="small"
                                                        error={
                                                            formikProps.errors.beyanYili &&
                                                                formikProps.touched.beyanYili
                                                                ? true
                                                                : false
                                                        }
                                                        value={formikProps.values.beyanYili}
                                                        onChange={(value) => {
                                                            formikProps.setFieldValue(
                                                                "beyanYili",
                                                                Number(value.target.value)
                                                            );
                                                        }}
                                                    >
                                                        {yilListe.map((option) => (
                                                            <MenuItem key={option.yili} value={option.yili}>
                                                                {option.yili}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </div>
                                                <div className="col-lg-3">
                                                    <TextField
                                                        fullWidth
                                                        className="mb-3"
                                                        select
                                                        size="small"
                                                        label="Beyan Ayı *"
                                                        error={
                                                            formikProps.errors.beyanAyi &&
                                                                formikProps.touched.beyanAyi
                                                                ? true
                                                                : false
                                                        }
                                                        value={formikProps.values.beyanAyi}
                                                        onChange={(value) => {
                                                            formikProps.setFieldValue(
                                                                "beyanAyi",
                                                                Number(value.target.value)
                                                            );
                                                        }}
                                                    >
                                                        <MenuItem value={1}>Ocak</MenuItem>
                                                        <MenuItem value={2}>Şubat</MenuItem>
                                                        <MenuItem value={3}>Mart</MenuItem>
                                                        <MenuItem value={4}>Nisan</MenuItem>
                                                        <MenuItem value={5}>Mayıs</MenuItem>
                                                        <MenuItem value={6}>Haziran</MenuItem>
                                                        <MenuItem value={7}>Temmuz</MenuItem>
                                                        <MenuItem value={8}>Ağustos</MenuItem>
                                                        <MenuItem value={9}>Eylül</MenuItem>
                                                        <MenuItem value={10}>Ekim</MenuItem>
                                                        <MenuItem value={11}>Kasım</MenuItem>
                                                        <MenuItem value={12}>Aralık</MenuItem>
                                                    </TextField>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 mb-3">
                                    <div className="card shadow-none border w-100">
                                        <div className="bg-white px-3 py-1 small fw-semibold">
                                            VERGİ HESAPLAMA BİLGİLERİ
                                        </div>
                                        <div className="card-body">
                                            {/* Başlık satırı */}
                                            <Grid container sx={{ display: { xs: 'none', sm: 'flex' } }} spacing={1} alignItems="center" textAlign="center">
                                                <Grid item xs={12} sm={3} />
                                                <Grid item xs={4} sm={3}>
                                                    <Typography variant="body2" fontWeight="bold" >
                                                        Vergiye Tabi Olan Prim Tutarı (1)
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={4} sm={3}>
                                                    <Typography variant="body2" fontWeight="bold">
                                                        % (Oranı) (2)
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={4} sm={3}>
                                                    <Typography variant="body2" fontWeight="bold">
                                                        % Ödenecek Vergi (3) = (1×2)
                                                    </Typography>
                                                </Grid>
                                            </Grid>

                                            {/* MENKUL */}
                                            <Grid container spacing={1} alignItems="center" sx={{ mt: 1 }}>
                                                <Grid item xs={12} sm={3}>
                                                    <Typography variant="body2" fontWeight="bold">
                                                        Menkul
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        name="vergiyeTabiMenkulPrim"
                                                        label="Vergiye Tabi Olan Prim Tutarı (1)"
                                                        sx={{
                                                            "& .MuiInputLabel-root": {
                                                                display: { xs: "block", sm: "none" }
                                                            }
                                                        }}
                                                        value={formikProps.values.vergiyeTabiMenkulPrim || ""}
                                                        onChange={formikProps.handleChange}
                                                        onBlur={formikProps.handleBlur}
                                                        inputProps={{ inputMode: "numeric" }}
                                                        InputProps={{ notched: false }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        name="yanginSigortaMnkOran"
                                                        label="% (Oranı) (2)"
                                                        sx={{
                                                            "& .MuiInputLabel-root": {
                                                                display: { xs: "block", sm: "none" }
                                                            }
                                                        }}
                                                        value={oranlar.mnk ?? ""}
                                                        inputProps={{ inputMode: "numeric" }}
                                                        InputProps={{ notched: false }}
                                                        disabled
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        name="menkulOdenecekVergi"
                                                        label="% Ödenecek Vergi (3) = (1×2)"
                                                        sx={{
                                                            "& .MuiInputLabel-root": {
                                                                display: { xs: "block", sm: "none" }
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                textAlign: "right"
                                                            }
                                                        }}
                                                        InputProps={{ notched: false }}
                                                        value={(
                                                            (Number(formikProps.values.vergiyeTabiMenkulPrim) || 0) *
                                                            (Number(oranlar.mnk) || 0)
                                                        ).toLocaleString("tr-TR", {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                        })}
                                                    />
                                                </Grid>
                                            </Grid>

                                            {/* GAYRİMENKUL */}
                                            <Grid container spacing={1} alignItems="center" sx={{ mt: 1 }}>
                                                <Grid item xs={12} sm={3}>
                                                    <Typography variant="body2" fontWeight="bold">
                                                        Gayrimenkul
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        name="vergiyeTabiGmenkulPrim"
                                                        label="Vergiye Tabi Olan Prim Tutarı (1)"
                                                        sx={{
                                                            "& .MuiInputLabel-root": {
                                                                display: { xs: "block", sm: "none" }
                                                            }
                                                        }}
                                                        value={formikProps.values.vergiyeTabiGmenkulPrim || ""}
                                                        onChange={formikProps.handleChange}
                                                        onBlur={formikProps.handleBlur}
                                                        inputProps={{ inputMode: "numeric" }}
                                                        InputProps={{ notched: false }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        name="yanginSigortaGmnkOran"
                                                        label="% (Oranı) (2)"
                                                        sx={{
                                                            "& .MuiInputLabel-root": {
                                                                display: { xs: "block", sm: "none" }
                                                            }
                                                        }}
                                                        value={oranlar.gmnk ?? ""}
                                                        inputProps={{ inputMode: "numeric" }}
                                                        InputProps={{ notched: false }}
                                                        disabled
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        name="gmenkulOdenecekVergi"
                                                        label="% Ödenecek Vergi (3) = (1×2)"
                                                        sx={{
                                                            "& .MuiInputLabel-root": {
                                                                display: { xs: "block", sm: "none" }
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                textAlign: "right"
                                                            }
                                                        }}
                                                        InputProps={{ notched: false }}
                                                        value={(
                                                            (Number(formikProps.values.vergiyeTabiGmenkulPrim) || 0) *
                                                            (Number(oranlar.gmnk) || 0)
                                                        ).toLocaleString("tr-TR", {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                        })}
                                                        onChange={formikProps.handleChange}
                                                    />
                                                </Grid>
                                            </Grid>

                                            {/* TOPLAM */}
                                            <Grid container spacing={1} alignItems="center" sx={{ mt: 1 }}>
                                                <Grid item xs={12} sm={3}>
                                                    <Typography variant="body2" fontWeight="bold">
                                                        TOPLAM
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        name="topVergiyeTabiPrim"
                                                        label="Vergiye Tabi Olan Prim Tutarı (1)"
                                                        sx={{
                                                            "& .MuiInputLabel-root": {
                                                                display: { xs: "block", sm: "none" }
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                textAlign: "right"
                                                            }
                                                        }}
                                                        InputProps={{ notched: false }}
                                                        value={(
                                                            (Number(formikProps.values.vergiyeTabiMenkulPrim) || 0) +
                                                            (Number(formikProps.values.vergiyeTabiGmenkulPrim) || 0)
                                                        ).toLocaleString("tr-TR", {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                        })}
                                                        disabled
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={3} /> {/* boş hücre */}
                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        name="topOdeneckVergi"
                                                        label="% Ödenecek Vergi (3) = (1×2)"
                                                        sx={{
                                                            "& .MuiInputLabel-root": {
                                                                display: { xs: "block", sm: "none" }
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                textAlign: "right"
                                                            }
                                                        }}
                                                        InputProps={{ notched: false }}
                                                        value={(
                                                            (
                                                                (Number(formikProps.values.vergiyeTabiMenkulPrim) || 0) * (Number(oranlar.mnk) || 0) +
                                                                (Number(formikProps.values.vergiyeTabiGmenkulPrim) || 0) * (Number(oranlar.gmnk) || 0)
                                                            )
                                                        ).toLocaleString("tr-TR", {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                        })}
                                                        disabled
                                                    />
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </div>
                                </div>

                                <div ref={documentTableRef}>
                                    {!docsLoaded ? (
                                        <div className="d-flex justify-content-center my-2"><CircularProgress size={24} /></div>
                                    ) : (
                                        <DocumentTable rows={documents} onUpdateDocuments={handleUpdateDocuments} />
                                    )}
                                </div>
                                <div className="col-12 mt-3">
                                    <div className="d-flex justify-content-end align-self-stretch">

                                        <Recaptcha
                                            ref={recaptchaRef}
                                            changeHandleRecaptcha={setRecaptchaPassed}
                                        />

                                        <Button
                                            onClick={() => showToastIfErrorsExist()}
                                            type="submit"
                                        >
                                            Gönder
                                        </Button>
                                        {loadingSubmit && (
                                            <div
                                                style={{
                                                    position: "fixed",
                                                    inset: 0,
                                                    background: "rgba(255,255,255,0.6)",
                                                    zIndex: 1300,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <CircularProgress />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {isPopupVisible ? (
                                    <BilgilendirmePopup
                                        basvuruTuruId={formikProps.values.basvuruTuruId}
                                        isSorunBildirPopup={!kayitBasarili}
                                        closePopup={closePopupSonuc}
                                        open={isPopupVisible}
                                        editDescription={popupAciklama}
                                    />
                                ) : null}
                            </div>
                        </Form>
                    );
                }}
            </Formik>
    );
};

export default YanginSigortaVergisiBasvuru;
